<template>
    <div class="content-wrapper">
        <app-page-top-section :title="product.name">
            <button class="btn btn-primary" @click="isModalActive = true">
                {{ $t('edit') }}
            </button>
            <button class="btn btn-success" @click="statusModal = true" v-if="product.status.name === 'status_draft'">
                {{ $t('publish') }}
            </button>
        </app-page-top-section>

        <div class="row">
            <div class="col-md-4 mb-4 mb-md-0">
                <div class="card border-0 card-with-shadow">
                    <form @submit.prevent="submitData" :data-url="`${PRODUCTS}/${product.slug}`"
                          enctype="multipart/form-data" method="post"
                          ref="form">
                        <div class="card-body">
                            <!--                            <div class="d-flex align-items-center justify-content-between mb-primary">-->
                            <!--                                <h5 class="card-title mb-0">-->
                            <!--                                    {{$t('thumbnails')}}-->
                            <!--                                </h5>-->
                            <!--                            </div>-->
                            <!--                            <hr>-->
                            <div>
                                <div class="row">
                                    <div class="col-6">
                                        <h5 class="card-title my-4">
                                            {{ $t('default_image') }}
                                        </h5>
                                    </div>
                                    <div class="col-6">
                                        <app-input
                                                :generate-file-url="false"
                                                :label="$t('choose_file')"
                                                type="custom-file-upload"
                                                v-if="default_image"
                                                v-model="default_image"
                                                @change="submitData"
                                        />
                                    </div>
                                </div>

                                <hr>
                                <!--                                <h5 class="card-title my-4">-->
                                <!--                                    {{ $t('product_images') }}-->
                                <!--                                </h5>-->
                                <!--                                <div class="mb-4">-->

                                <!--                                    <app-input-->
                                <!--                                            :error-message="error_message"-->
                                <!--                                            :generate-file-url="false"-->
                                <!--                                            type="dropzone"-->
                                <!--                                            v-if="dropZoneBoot"-->
                                <!--                                            v-model="product_images"-->
                                <!--                                    />-->
                                <!--                                </div>-->

                                <!--                                <div class="form-group mb-0">-->
                                <!--                                    <app-submit-button :loading="loading"-->
                                <!--                                                       @click="submitData"/>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="col-md-8 mb-4 mb-md-0">
                <div class="card border-0 card-with-shadow">
                    <div class="card-body">
                        <div class="d-flex align-items-center justify-content-between mb-primary">
                            <h5 class="card-title mb-0">
                                {{$t('details')}}
                            </h5>
                            <!--<div class="dropdown options-dropdown d-none">
                                <button class="btn-option btn" data-toggle="dropdown" type="button">
                                    <app-icon name="more-vertical"/>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right py-2 mt-1">
                                    <a @click.prevent="redirectEditPage()" class="dropdown-item px-4 py-2" href="#">
                                        {{$t('edit')}}
                                    </a>
                                    <a @click.prevent="confirmationModalActive = true" class="dropdown-item px-4 py-2"
                                       href="#">
                                        {{$t('delete')}}
                                    </a>
                                </div>
                            </div>-->
                        </div>
                        <div>
                            <div class="mb-4">
                                <p class="text-muted mb-0">{{$t('name')}}</p>
                                <p>{{product.name}}</p>
                            </div>

                            <div class="mb-4">
                                <p class="text-muted mb-0">{{$t('Categories')}}</p>
                                <p>{{ collection(product.categories).pluck('name').join(', ') }}</p>
                            </div>

                            <div class="mb-4">
                                <p class="text-muted mb-0">{{ $t('status') }}</p>
                                <p>
                                    <span :class="`text-${$optional(product.status, 'class')}`">
                                        {{ $optional(product.status, 'translated_name') }}
                                    </span>
                                </p>
                            </div>

                            <div class="mb-4">
                                <p class="text-muted mb-0">{{$t('Brand')}}</p>
                                <p>{{ $optional(product.brand, 'name') }}</p>
                            </div>

                            <div class="mb-4">
                                <p class="text-muted mb-0">{{$t('description')}}</p>
                                <p>
                                    {{ Boolean(product.description) && product.description !== 'null' ? product.description : '' }}
                                </p>
                            </div>
                            <div class="mb-4">
                                <p class="text-muted mb-0">{{$t('Unit')}}</p>
                                <p class="text-left">
                                    {{ product.unit }} {{(product.unit_type)}}
                                </p>
                            </div>


                            <div class="mb-4" v-if="creationDate">
                                <p class="text-muted mb-0">{{$t('creation_date')}}</p>
                                <p>{{creationDate}}</p>
                            </div>
                        </div>
                        <hr>
                        <div>
                            <h5 class="card-title my-4">
                                {{ $t('pricing') }}
                            </h5>
                            <div class="mb-4">
                                <p class="text-muted mb-0">{{ $t('purchase_price') }}</p>
                                <p>{{ product.purchase_price }}</p>
                            </div>
                            <div class="mb-4">
                                <p class="text-muted mb-0">{{ $t('sell_price') }}</p>
                                <p>{{ product.sell_price }}</p>
                            </div>
                            <div class="mb-4">
                                <p class="text-muted mb-0">{{ $t('total_discount_amount') }}</p>
                                <p>{{ product.default_discount }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <app-product-create-edit
                v-if="isModalActive"
                v-model="isModalActive"
                :selected-url="`${apiUrl.PRODUCTS}/${product.slug}`"
                @success="reloadPage"
        />

        <app-confirmation-modal
                v-if="statusModal"
                icon="activity"
                modal-id="app-status-confirmation-modal"
                :subTitle="''"
                :message="statusMessage"
                @confirmed="updateStatus"
                @cancelled="statusModal = false"
        />
    </div>

</template>
R
<script>
    import DeleteMixin from "../../../Mixins/DeleteMixin";
    import {axiosPatch, urlGenerator} from "../../../Helpers/AxiosHelper";
    import FormHelperMixin from "../../../Mixins/FormHelperMixin";
    import {PRODUCT_LIST, PRODUCTS} from "../../../Config/ApiUrl";
    import {collection, formatDateToLocal, formDataAssigner} from "../../../Helpers/Helpers";

    export default {
        name: "Product",
        mixins: [DeleteMixin, FormHelperMixin],

        props: {
            product: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                urlGenerator,
                default_image: {},
                product_images: [],
                allProductImages: [],
                dropZoneBoot: true,
                error_message: "",
                isModalActive: false,
                statusModal: false,
                statusMessage: '',
                PRODUCTS,
                PRODUCT_LIST
            }
        },
        methods: {
            submitData() {
                this.loading = true;
                this.message = '';
                this.errors = {};
                let formData = formDataAssigner(new FormData, this.getSelectedProduct);

                formData.append('categories', collection(this.product.categories).pluck('id'))

                if (this.default_image && this.default_image instanceof File) {
                    formData.append('default_image', this.default_image);
                }

                this.product_images.forEach(image => {
                    image instanceof File ?
                        formData.append('product_images[]', image) :
                        formData.append(`dont_delete[]`, this.allProductImages.find(file => {
                            return file.url === image.dataURL
                        }).id)
                })

                return this.save(formData);
            },
            redirectEditPage() {
                window.location = PRODUCT_LIST
            },
            afterSuccess({data}) {
                this.toastAndReload(data.message);
                location.reload();
            },

            updateStatus() {
                axiosPatch(urlGenerator(`${PRODUCTS}/${this.product.slug}/change-status`))
                    .then(response => {
                        this.toastAndReload(response.data.message);
                        this.reloadPage();
                    })
            },
            reloadPage() {
                location.reload();
            }
        },
        computed: {
            creationDate() {
                return formatDateToLocal(this.product.created_at)
            },
            getSelectedProduct() {
                const product = {...this.product};

                ['brand', 'categories', 'updated_at', 'image'].forEach((key) => {
                    delete product[key]
                })
                product._method = 'PATCH'
                return product;
            }
        },
        watch: {
            product: {
                handler: function (product) {
                    Object.keys(product).length;
                    if (typeof product === "object") {
                        if (product.image) {
                            this.default_image = false
                            this.default_image = product.image.full_url
                        }

                        if (product?.images?.length) {
                            this.dropZoneBoot = false
                            this.product_images = product.images.map(e => {
                                this.allProductImages.push({
                                    id: e.id,
                                    url: e.full_url
                                })
                                return e.full_url;
                            })
                        }

                        setTimeout(() => this.dropZoneBoot = true)
                        setTimeout(() => this.default_image = true)
                    }
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>